import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getCampaignEmails } from "api/CampaignApi";
import { useDispatch, useSelector } from "react-redux";
import {
  setCampaignAudienceName,
  setCampaignAudienceId,
  setComplaiceStatus,
  setCampaignEmail,
  setCC,
  setBCC,
  setCampaignId
} from "ReduxStore/Slices/campaignSlice";
import CreatableSelect from "react-select/creatable";
import { postCampaignData, putCampaignData } from "api/CampaignApi";


const createOption = (label) => ({
  label,
  value: label.toLowerCase().replace(/\W/g, ""),
  status: null
});


export default function CampaignSelectEmail() {
  const [campaignEmailList, setCampaignEmailList] = useState([
    { label: "Please Select", value: "" },
  ]);
  const { campaignEmail, campaignViewMode } = useSelector(
    (state) => state.campaignSetter
  );
  const campaignData = useSelector((state) => state.campaignSetter);

  const dispatch = useDispatch();

  const [cc, setCC_] = useState([])
  const [Allcc, setAllCC] = useState([])
  
  const [bcc, setbcc] = useState([])
  const [Allbcc, setAllbcc] = useState([])
  
  const [isLoading, setIsLoading] = useState(false);

  

  const handleChange1 = (newValue, actionMeta) => {
    setCC_(newValue);
};
const handleChange2 = (newValue, actionMeta) => {
  setbcc(newValue);
};

  const handleCreate1 = (inputValue) => {
    setIsLoading(true);
    console.group("Option created");

    setTimeout(() => {
        const newOption = createOption(inputValue);
        setCC_([...cc, newOption]);
        setIsLoading(false);
    }, 1000);
};
const handleCreate2 = (inputValue) => {
    setIsLoading(true);
    console.group("Option created");

    setTimeout(() => {
        const newOption = createOption(inputValue);
        setbcc([...bcc, newOption]);
        setIsLoading(false);
    }, 1000);
};

function savecc(e){
  e.preventDefault();
  let ccList = [];
  let bccList = [];
  cc.map((c)=>{
    ccList.push(c.label);
  })
  bcc.map((c)=>{
    bccList.push(c.label);
  })
  sessionStorage.setItem("ccList", JSON.stringify(ccList));
  sessionStorage.setItem("bccList", JSON.stringify(bccList));

  console.log(ccList, bccList);

  dispatch(setBCC(bccList));
  dispatch(setCC(ccList));

  // postCampaignData({cc:ccList, bcc:bccList}, campaignData.campaignId)
  // .then((data) => {
  //   console.log(data);
  //   if (!campaignData.campaignId) {
  //     dispatch(setCampaignId(data.id));
  //   }

  // })
  // .catch((e) => {
  //   console.log(e);
  // });

  // dispatch(setCampaignAudienceName(ccList));
  // dispatch(setCampaignAudienceId(bccList));
  // dispatch(setComplaiceStatus("Editing"));
}


  useEffect(() => {
    let emails = [];
    var i = 0;
    getCampaignEmails()
      .then((data) => {
        data.emails.map((email) => {
          i++;
          emails.push({
            label: email,
            value: email,
          });
          if (data.emails.length === i) {
            setCampaignEmailList(emails);
          }
        });
      })
      .catch((e) => { });
  }, []);

  return (
    <>
    <div className="row justify-content-between align-items-end pt_15">
      <div className="left_sec">
        <div className="max534">
          <label>From Email</label>
          <p className="campaign_text">Select the sender's email</p>
        </div>
      </div>
      <div className="right_sec">
        <div style={{ width: 400, height: 50 }}>
          <Select
            id="audId"
            isClearable
            value={{
              value: campaignEmail,
              label: campaignEmail,
            }}
            onChange={(e, { action }) => {
              dispatch(setCampaignEmail(null));
              if (e !== null) {
                dispatch(setCampaignEmail(e.value));
              }
              dispatch(setComplaiceStatus("Editing"));
            }}
            options={campaignEmailList}
            required
            isDisabled={campaignViewMode}
          />
          <input
            tabIndex={-1}
            autoComplete="off"
            style={{ opacity: 0, height: 0 }}
            required={!campaignEmail}
            id="tt"
          />
        </div>
      </div>
    </div>

    <div className="row justify-content-between align-items-end pt_15">
      <div className="left_sec">
        {/* <div className="max534">
          <label>From Email</label>
          <p className="campaign_text">Select the sender's email</p>
        </div> */}
      </div>
      <div className="right_sec">
       {  <a
          href="#"
          data-toggle={ "modal" }
          data-target={  "#CC_BCC"}
          style={{color:"blue"}}
        
        >
          Add CC/BCC

        </a>}

        <div class="modal fade kwDesignModal kwScheduleModal" id='CC_BCC' >
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title" style={{paddingLeft:"10px"}}>Add CC/BCC</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-6">
                    <label>CC</label>
                    {console.log("CC BCCCCCCCCCCCCC",cc,bcc)}
                    {/* <input type="text" class="kwDesign" /> */}
                    <CreatableSelect
                                        isMulti={true}
                                        isClearable
                                        formatCreateLabel={(val) => <span>Add {val}</span>}
                                        value={cc}

                                        placeholder={"Add.."}
                                        onChange={handleChange1}
                                        onCreateOption={handleCreate1}
                                        isDisabled={isLoading}
                                        isLoading={isLoading}
                                    />
                  </div>
                  <div class="col-md-6">
                    <label>BCC</label>
                    <CreatableSelect
                                        isMulti={true}
                                        isClearable
                                        formatCreateLabel={(val) => <span>Add {val}</span>}
                                        value={bcc}

                                        placeholder={"Add.."}
                                        onChange={handleChange2}
                                        onCreateOption={handleCreate2}
                                        isDisabled={isLoading}
                                        isLoading={isLoading}
                                    />
                  </div>
                </div>
              </div>
              <div class="modal-footer">
              <input
                        type="submit"
                        className="lg_btn primary"
                        value="Save"
                        id="finalize"
                        data-dismiss="modal"
                        onClick={(e) => savecc(e)}
                      />
                  
              </div>

          </div>
        </div>
            
            

        </div>
      </div>
    </div>
    </>
  );
}
